;(function() {
  'use strict'

  service.$inject = ["$rootScope", "$q", "pagesResource", "colorService"];
  angular.module('core.services').factory('pageService', service)

  /* @ngInject */
  function service($rootScope, $q, pagesResource, colorService) {
    return {
      get: get,
      getByElement: getByElement,
      addExtras: addExtras,
    }

    function get(id) {
      return $q(function(resolve, reject) {
        pagesResource
          .get({ id: id })
          .success(function(resource, page) {
            addExtras(page)
            resolve(page)
          })
          .error(function(response, status) {
            reject({
              response: response,
              status: status,
            })
          })
      })
    }

    function getByElement(elementId) {
      return $q(function(resolve, reject) {
        pagesResource
          .get({ elementId: elementId })
          .success(function(resource, pages) {
            addExtras(pages)
            resolve(pages)
          })
          .error(function(response, status) {
            reject({
              response: response,
              status: status,
            })
          })
      })
    }

    function addExtras(pages) {
      if (!_.isArray(pages)) {
        pages = [pages]
      }
      _.each(pages, function(page) {
        // defaults/fixes
        if (!page.themeColor || page.themeColor[0] !== '#') {
          page.themeColor = '#dcdcdc' // default
        }

        // extras
        var extras = {}
        extras.themeColorLight = colorService.lighten(page.themeColor, 10)
        extras.themeColorText = colorService.textForBg(page.themeColor)
        extras.featureStyles = {
          'background-image': 'url(' + page.featureImageUrl + ')',
          'background-color': extras.themeColorLight,
        }
        extras.logoStyles = {
          'background-image': 'url(' + page.logoUrl + ')',
        }
        extras.bgWithTextStyles = {
          'background-color': page.themeColor,
          color: extras.themeColorText,
        }
        extras.bgWithTextStylesInversed = {
          'background-color': extras.themeColorText,
          color: page.themeColor,
        }
        page.extras = extras
      })
    }
  }
})()
